/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Methods_None_LeftInputs */



/**
* | output |
* | --- |
* | "This leaves no sign-in method. Unless the member already has a passkey, they will not be able to sign in." |
*
* @param {Member_Login_Methods_None_LeftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_methods_none_left = /** @type {((inputs?: Member_Login_Methods_None_LeftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Methods_None_LeftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Damit bleibt keine Anmeldemethode übrig. Sofern das Mitglied nicht bereits einen Passkey hat, kann es sich nicht mehr anmelden.")
	return /** @type {LocalizedString} */ ("This leaves no sign-in method. Unless the member already has a passkey, they will not be able to sign in.")
});